import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

export const DEFAULT_SETTINGS = {
  church_name: "La Maison de la Charité",
  city_line: "Montévrain / Val d'Europe — Seine-et-Marne",
  meeting_name: "Charity Times",
  meeting_weekday: 5,
  meeting_time: "16h00",
  welcome_time: "15h30",
  address: "Salle Matisse — Résidence du Parc, 2 Rue Edouard Buffard, 77144 Montévrain",
  maps_url: "https://www.google.com/maps/search/?api=1&query=R%C3%A9sidence%20du%20Parc%2C%202%20Rue%20Edouard%20Buffard%2C%2077144%20Mont%C3%A9vrain",
  cta_text: "Je viens à Charity Times",
  contact_email: "lamaisondelacharite@gmail.com",
  phone: "06 95 52 67 18",
  instagram: "https://www.instagram.com/lamaisond",
  youtube: "https://youtube.com/@lamaisondelacharite",
  tiktok: "https://www.tiktok.com/@lamaisondelachari7",
  whatsapp: "https://wa.me/qr/ZAZ4C6NPCL6JD1",
  iban: "FR76 1695 8000 0119 4739 9461 713",
  bic: "QNTOFRP1XXX",
};

const SettingsContext = createContext({ settings: DEFAULT_SETTINGS, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULT_SETTINGS, ...data });
    } catch {
      // garde les valeurs par défaut
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);

// weekday : convention Python (lundi = 0 ... dimanche = 6)
export function nextMeetingDate(weekday = 6, timeStr = "10h00") {
  const m = /^\s*(\d{1,2})[h:](\d{2})/.exec(timeStr || "");
  const h = m ? parseInt(m[1], 10) : 10;
  const min = m ? parseInt(m[2], 10) : 0;
  const jsDay = (weekday + 1) % 7;
  const now = new Date();
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, min);
  let delta = (jsDay - d.getDay() + 7) % 7;
  if (delta === 0 && d.getTime() < now.getTime() - 4 * 3600 * 1000) delta = 7;
  d.setDate(d.getDate() + delta);
  return d;
}

export const WEEKDAYS_FR = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

// Prochaine rencontre : d'abord les dates explicites (ex. un samedi sur deux),
// sinon calcul hebdomadaire à partir du jour de la semaine.
export function nextMeeting(settings) {
  const m = /^\s*(\d{1,2})[h:](\d{2})/.exec(settings.meeting_time || "");
  const h = m ? parseInt(m[1], 10) : 16;
  const min = m ? parseInt(m[2], 10) : 0;
  const recs = settings.recurring || [];
  const rec = recs.find((r) => r.title === settings.meeting_name) || recs[0];
  const now = Date.now();
  if (rec && Array.isArray(rec.dates) && rec.dates.length) {
    for (const ds of [...rec.dates].sort()) {
      const dt = new Date(`${ds}T${String(h).padStart(2, "0")}:${String(min).padStart(2, "0")}:00`);
      if (dt.getTime() > now - 4 * 3600 * 1000) return dt;
    }
  }
  return nextMeetingDate(settings.meeting_weekday, settings.meeting_time);
}
